module.exports = __webpack_public_path__ + "static/img/480x320-blade.6ea3b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/480x320-blade.png
// module id = 33OM
// module chunks = 1